/**
 * ScrollToTop — global route-change scroll manager.
 *
 * React Router does NOT auto-scroll to top on navigation (SPAs preserve
 * scroll position by default). This causes pages linked from the bottom
 * of another page to open scrolled to their own bottom — bad UX.
 *
 * Mounted once inside <BrowserRouter> in App.js. Every pathname change
 * triggers a jump to (0, 0). Hash links (`#section`) are respected —
 * they scroll to the target element instead of the top.
 *
 * SPECIAL CASE: when returning to `/peirateia` from a deep-dive page
 * (proelefsi / tehnika / pnematiki-parakampsi / trietis / dimiourgos),
 * we honour the saved scroll position and skip the reset — so the user
 * lands exactly where they were before clicking the deep-dive link.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // Let the browser handle hash scrolling to the anchor
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "auto", block: "start" });
        return;
      }
    }
    // Skip the reset when returning to the brand page with a saved scroll position
    // (set by `goToDeepDive` in PeirateiaPage before navigating to a deep-dive).
    if (pathname === "/peirateia") {
      try {
        const saved = sessionStorage.getItem("peirateia_return_scroll");
        if (saved && parseInt(saved, 10) > 0) return;
      } catch { /* ignore */ }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);
  return null;
}
